import { AgTableClient } from "app/shared/AgTable";
import PageHeader from "app/shared/PageHeader";
import React from "react";
const Dashboard = () => {
    return (
        <>
            <iframe
                       height="100%"
                       style={{ width: "100%" }}
                       scrolling="no"
                       title="Iframe"
                       id="dashboardFrame"
                       src={
                         //getFormattedURL(dashboardURLConfig[domain]?.[activeKey]) ||
                         "https://analytics.zoho.in/open-view/103074000044928630/22842cd9f0fc8b0410814e75610a759c"
                       }
                     ></iframe>
        </>
    )
};
export default Dashboard;

